import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

type NgUseContext = { $implicit: any; oscNgUse: any };

@Directive({
    selector: '[oscNgUse]',
    standalone: false
})
export class NgUseDirective {
    @Input()
    public set oscNgUse(context: unknown) {
        this.context.$implicit = this.context.oscNgUse = context;
        this.updateView();
    }

    private context: NgUseContext = {} as NgUseContext;

    public constructor(
        private vcRef: ViewContainerRef,
        private templateRef: TemplateRef<NgUseContext>
    ) {}

    private updateView() {
        this.vcRef.clear();
        this.vcRef.createEmbeddedView<NgUseContext>(this.templateRef, this.context);
    }
}
